import { createFileRoute } from '@tanstack/react-router';

import { PublicShareViewerPage } from '@/pages/public-share/public-share-viewer-page';

/**
 * `/share/<token>` — anonymous read-only viewer for a project or task
 * that a team member shared via Track C / Step 4.
 *
 * Listed in `__root.tsx#isPublicPath` so the auth guard doesn't kick
 * unauthenticated viewers to /login.
 */
export const Route = createFileRoute('/share/$token')({
  component: PublicShareViewerPage,
});
